export default "/WebApp/dist/assets/fonts/glyphicons-halflings-regular.eot";